import siteFacts from "./site-facts.json" with { type: "json" };

export const site = {
  name: siteFacts.name,
  canonicalOrigin: siteFacts.canonicalOrigin,
  docsOrigin: siteFacts.docsOrigin,
  agentSummary: siteFacts.agentSummary,
} as const;

export const sitePaths: Readonly<typeof siteFacts.paths> = siteFacts.paths;

export function canonicalSiteUrl(path: string): string {
  return new URL(path, `${site.canonicalOrigin}/`).toString();
}

function canonicalDocsUrl(path: string): string {
  const base = site.docsOrigin.endsWith("/")
    ? site.docsOrigin
    : `${site.docsOrigin}/`;
  const relative = path === "/" ? "" : path.replace(/^\//, "");
  return new URL(relative, base).toString();
}

export const publicLinks = {
  contactEmail: siteFacts.contactEmail,
  contactEmailHref: `mailto:${siteFacts.contactEmail}`,
  ...siteFacts.links,
} as const;

export const agentDestinations = {
  docsIndex: canonicalDocsUrl(siteFacts.docsPages.agentIndex),
  agentCatalog: canonicalSiteUrl(sitePaths.ard),
  apiCatalog: canonicalSiteUrl(sitePaths.apiCatalog),
  platformOverview: canonicalDocsUrl(siteFacts.docsPages.platformOverview),
  quickstart: canonicalDocsUrl(siteFacts.docsPages.quickstart),
  authentication: canonicalDocsUrl(siteFacts.docsPages.authentication),
  skill: canonicalDocsUrl(siteFacts.docsPages.skill),
  play: canonicalSiteUrl(sitePaths.playMarkdown),
  onboarding: canonicalSiteUrl(sitePaths.onboardingMarkdown),
  apiOverview: canonicalDocsUrl(siteFacts.docsPages.apiOverview),
  apiBase: canonicalSiteUrl(sitePaths.apiBase),
  openApi: canonicalSiteUrl(sitePaths.openApi),
  browse: canonicalSiteUrl(sitePaths.browse),
  coworldDirectory: canonicalSiteUrl(sitePaths.coworldDirectory),
  coworldIndex: canonicalSiteUrl(sitePaths.coworldIndex),
  coworldFullIndex: canonicalSiteUrl(sitePaths.coworldFullIndex),
} as const;
